import { loadOrder, removeOrder, addOrder } from "../cache";
import * as types from "./mutation-types";

const state = {
    orderList: loadOrder() || [],
};
const mutations = {
    [types.REMOVE_ORDER](state, orderId) {
        var orderList = state.orderList;
        let index = orderList.indexOf(orderId);
        orderList.splice(index, 1);
    },
    [types.ADD_ORDER](state, orderId) {
        state.orderList.push(orderId);
    },
};
const actions = {
    addOrderToList({ commit, state }, obj) {
        if (state.orderList.indexOf(obj) < 0)
            commit(types.ADD_ORDER, addOrder(obj))
    },
    removeOrderFromList({ commit }, obj) {
        commit(types.REMOVE_ORDER, removeOrder(obj))
    }
}
const getters = {
    orderList: (state) => state.orderList,
};
export default {
    state,
    mutations,
    actions,
    getters,
};
